import React from "react";
import ThemeSelector from "./ThemeSelector";

const AVATAR_COLORS = [
  "bg-primary",
  "bg-secondary",
  "bg-info",
  "bg-success",
  "bg-warning",
  "bg-danger",
];

const getAvatarColor = (name) => {
  const sum = String(name || "")
    .split("")
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return AVATAR_COLORS[sum % AVATAR_COLORS.length];
};

const getInitials = (name) => {
  return String(name || "")
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();
};

const FooterProfileMenu = ({
  profileImage,
  profileLabel,
  onProfile,
  onSignOut,
  onProfileImageError,
}) => {
  const initials =
    profileLabel === "Guest User" ? "GU" : getInitials(profileLabel);

  return (
    <div className="dropdown me-3">
      <button
        className="btn btn-link nav-link p-0 d-flex align-items-center"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        title="Profile"
        style={{
          textDecoration: "none",
          width: "22px",
          height: "22px",
          borderRadius: "50%",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {profileImage ? (
          <img
            src={profileImage}
            className="rounded-circle"
            width={20}
            height={20}
            alt="profile"
            style={{ objectFit: "cover" }}
            onError={onProfileImageError}
          />
        ) : (
          <div
            className={`${getAvatarColor(profileLabel)} text-white rounded-circle d-flex align-items-center justify-content-center`}
            style={{
              width: "20px",
              height: "20px",
              fontSize: "10px",
              fontWeight: "bold",
              fontFamily:
                "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              lineHeight: "20px",
              textAlign: "center",
              padding: 0,
            }}
          >
            {initials}
          </div>
        )}
      </button>
      <ul className="dropdown-menu dropdown-menu-end">
        <li>
          <button
            type="button"
            className="p-2 dropdown-item h6 rounded-1 border-0 bg-transparent w-100 text-start"
            onClick={onProfile}
          >
            My Profile
          </button>
        </li>
        <li>
          <ThemeSelector variant="dropdown" />
        </li>
        <li>
          <button
            type="button"
            className="p-2 dropdown-item h6 rounded-1 border-0 bg-transparent w-100 text-start"
            onClick={onSignOut}
          >
            Sign Out
          </button>
        </li>
      </ul>
    </div>
  );
};

export default FooterProfileMenu;
